"use client";

import { memo } from "react";
import Link, { LinkProps } from "next/link";
import { cn } from "@/lib/utils";
import Icon from "@/components/ui/Icon";

type CommonProps = {
  className?: string;  
  children: React.ReactNode;
};

type AnchorVariant = CommonProps &
  LinkProps & {
    href: string;
    ref?: React.Ref<HTMLAnchorElement>;
  };

type DivVariant = CommonProps &
  React.ComponentPropsWithoutRef<"div"> & {
    href?: undefined;
    ref?: React.Ref<HTMLDivElement>;
  };

type LanguageButtonLinkProps = AnchorVariant | DivVariant;

const LanguageButtonLink = ({
  href,
  children,
  className,
  ...rest
}: LanguageButtonLinkProps) => {
  const content = (
    <span
      className={cn(
        "group flex-auto min-w-0 flex group rounded-2xl border-1 bg-white items-center justify-between py-[19.5] px-6 md:py-3 cursor-pointer text-gray-500 text-lg leading-[130%] md:py-4 md:text-xl md:leading-[150%] border-blue-200 hover:border-[#2783FF] hover:shadow-[0_8px_16px_0_rgba(0,0,0,0.08)] transition-[box-shadow,border-color]",
        className
      )}
    >
      <span className="grid grid-cols-1 gap-3">
        <span>{children}</span>
      </span>
      <Icon
        id="icon-arrow-right_24"
        width={24}
        height={24}
        className="shrink-0 w-6 h-6 ml-2 hidden md:block group-hover:text-blue-500"
      />
    </span>
  );

  return href ? (
    <Link href={href} className="flex" {...(rest as Omit<AnchorVariant, 'href'>)}>
      {content}
    </Link>
  ) : (
    <div className="flex" {...(rest as DivVariant)}>
      {content}
    </div>
  );
};

export default memo(LanguageButtonLink);
